export default " <!-- <app-loader *ngIf=\"isLoader\"></app-loader> -->\n  <router-outlet></router-outlet>\n\n\n"